import Component from 'flarum/common/Component';

/**
 * Shared open/close lifecycle for the toolbar popovers.
 *
 * Handles document-level "click outside" and Escape listeners, and positions
 * the popover above its trigger. Subclasses only render the trigger and the
 * popover body, and call toggle() / close().
 */
export default class PopoverBase extends Component {
  isOpen = false;
  anchor = null;
  popoverEl = null;
  onDocClick = e => {
    if (!this.isOpen) return;
    const target = e.target;
    if (!target || !this.popoverEl) return;
    if (!this.popoverEl.contains(target) && !this.anchor?.contains(target)) {
      this.close();
    }
  };
  onKey = e => {
    if (e.key === 'Escape') this.close();
  };
  onremove() {
    this.detachListeners();
  }
  open() {
    if (this.isOpen) return;
    this.isOpen = true;
    document.addEventListener('mousedown', this.onDocClick);
    document.addEventListener('keydown', this.onKey);
  }
  close() {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.detachListeners();
    m.redraw();
  }
  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  /**
   * Fixed-position style placing the popover centred above the trigger.
   */
  anchorStyle() {
    if (!this.isOpen || !this.anchor) return null;
    const r = this.anchor.getBoundingClientRect();
    return {
      position: 'fixed',
      left: `${r.left + r.width / 2}px`,
      top: `${r.top}px`,
      transform: 'translate(-50%, calc(-100% - 8px))'
    };
  }
  detachListeners() {
    document.removeEventListener('mousedown', this.onDocClick);
    document.removeEventListener('keydown', this.onKey);
  }
}
flarum.reg.add('forumaker-magicbb', 'forum/components/PopoverBase', PopoverBase);